<template>
    <div id="admin-ads">
        <div v-for="ad in sortByStartDate(ads)" :key="ad.id" class="admin-wines-row" v-bind:class="{'admin-ad-active': isActive(ad.startDate, ad.endDate)}">
            <div class="admin-ad-col">
                <div class="row-header">Name</div>
                <div class="admin-blog-post-title">
                    {{ ad.name }}
                </div>
            </div>
            <div class="admin-ad-col">
                <div class="row-header">Clicks</div>
                <div class="admin-blog-post-datepublished">
                    {{ ad.clicks }}
                </div>
            </div>
            <div class="admin-ad-col">
                <div class="row-header">Page</div>
                <div class="admin-blog-post-datepublished">
                    {{ pageToText(ad.page) }}
                </div>
            </div>
            <div class="admin-ad-col">
                <div class="row-header">Type</div>
                <div class="admin-blog-post-datepublished">
                    {{ typeToText(ad.adType) }}
                </div>
            </div>
            <div class="admin-ad-col">
                <div class="row-header">Start Date</div>
                <div class="admin-blog-post-datecreated">
                    {{ displayDate(ad.startDate) }}
                </div>
            </div>
            <div class="admin-ad-col">
                <div class="row-header">End Date</div>
                <div class="admin-blog-post-datepublished">
                    {{ displayDate(ad.endDate) }}
                </div>
            </div>
            <div class="admin-wines-button" v-on:click="$emit('ad', 'EditAd', ad)">
                Edit
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    computed: {
        ...mapState(['ads'])
    },
    filters: {
        optimizeWine: function(url) {
            var newUrl = url.replace('upload/', 'upload/q_auto,f_auto,h_100/')
            return newUrl
        }
    },
    methods: {
        displayDate: function(timestamp) {
            if (timestamp) {
                timestamp = new Date(timestamp)
            return moment(timestamp).format('DD/MM/YYYY -  HH:mm')
            } else {
                return "Please select a date"
            }
        },
        isActive: function(startDate, endDate) {
            var now = new Date()
            if (Date.parse(startDate) < now && Date.parse(endDate) > now) return true
            return false
        },
        typeToText: function(type) {
            if (type == 'top') return 'Banner efst'
            if (type == 'bottom') return 'Banner neðst'
            if (type == 'wine') return 'Vín spjald'
            return type
        },
        pageToText: function (page) {
            if (page == "home") return "Heim"
            if (page == "catalog") return "Öll vín"
            if (page == "wine") return "Vín"
            if (page == "blog") return "Greinar"
            if (page == "food") return "Vín með mat"
            if (page == "contact") return "Hafa samband"
        },
        sortByStartDate(ads) {
            var copyAds = ads.slice()
            copyAds.sort(function(a,b){return Date.parse(b.startDate) - Date.parse(a.startDate)})
            return copyAds
        }
    }
}
</script>

<style>
.admin-ad-active {
    border: 3px solid #b33b3b;
}
.admin-ad-col {
    -ms-flex-preferred-size: 16.6%;
    flex-basis: 14.3%;
}
</style>